import Http from 'axios';

export default {
    namespaced: true,

    state: {
        events: [],
    },

    getters: {
        getPostById: (state) => (id) => {
            return state.events.find(event => event.id == id) || null;
        },
    },

    mutations: {
        setEvents(state, events) {
            state.events = events;
        },
    },

    actions: {
        loadEvents({ commit }) {
            return Http.get('/api/event/event').then(res => {
                commit('setEvents', res.data);
            });
        },
    }
}


// WEBPACK FOOTER //
// ../default-js/js/store/modules/event.js